import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import '@giftgroup/ui/styles/global.css';
import { AppProviders } from './app/Providers';
import { registerServiceWorker } from './features/notifications/push';
import { noteVisit } from './features/pwa/install';
import { initSentry } from './lib/sentry';
import { router } from './router';

void initSentry();

/*
 * The worker is what makes the app installable and caches the static shell (doc 05).
 * It used to be registered only when someone turned push on, which meant an installed
 * app had no shell cache until then. It's deliberately not awaited: nothing on screen
 * depends on it.
 */
void registerServiceWorker();
// Counted once per load, so the install tip can wait for a second visit (doc 05).
noteVisit();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element');

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
